<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">查看</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm5>
              <div class="x-text-field">
                <label>用户名</label>
                <div>{{item.username}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm5>
              <div class="x-text-field">
                <label>密码</label>
<!--            <div>{{item.password}}</div>-->
                <div>***</div>
              </div>
            </v-flex>

            <v-flex xs12 sm2>
              <div class="x-text-field">
                <label>禁用</label>
                <div>{{item.disabled ? '是' : '否'}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm4>
              <div class="x-text-field">
                <label>姓名</label>
                <div>{{item.name}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm4>
              <div class="x-text-field">
                <label>工号</label>
                <div>{{item.number}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm4>
              <div class="x-text-field">
                <label>出生日期</label>
                <div>{{item.birthday}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm2>
              <div class="x-text-field">
                <label>职称</label>
                <div>{{item.title? item.title.name : ''}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm2>
              <div class="x-text-field">
                <label>学位</label>
                <div>{{item.education? item.education.name : ''}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm4>
              <div class="x-text-field">
                <label>联系电话</label>
                <div>{{item.phone}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm4>
              <div class="x-text-field">
                <label>电子邮箱</label>
                <div>{{item.email}}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>部门及角色</label>
                <div>
                  {{item.deptRoles ? item.deptRoles.map(dr => `${dr.department.name}（${dr.role.name}）`).join(', '): ''}}
                </div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>备注</label>
                <div>{{item.note}}</div>
              </div>
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" @click.native="visible=false">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'

  const baseUri = '/api/syst/user';

  export default {
    mixins: [mixin.view(baseUri)],
    data() {
      return {
        item: {}
      }
    }
  }
</script>
